var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: "12" } },
        [
          _vm.$store.state.accounts.LoaderMe ||
          _vm.$store.state.documents.retrieveLoader
            ? _c("skeleton-list")
            : [
                !_vm.$helpers.hasSomePermission(["view_document"])
                  ? _c("PermissionDenied", {
                      attrs: {
                        isDetail: _vm.routeList.includes(_vm.$route.name),
                      },
                    })
                  : [
                      !_vm.documentsList?.length ||
                      (!_vm.routeList.includes(_vm.$route.name) &&
                        Object.keys(_vm.$route?.query).length === 0)
                        ? _c("v-empty-state", {
                            class: {
                              "mt-n2": _vm.routeList.includes(_vm.$route.name),
                            },
                            attrs: {
                              type: "documents",
                              id: "documentos",
                              customClass: _vm.routeList.includes(
                                _vm.$route.name
                              )
                                ? "mt-n6 pb-2"
                                : "mt-3",
                              isFree: _vm.routeList.includes(_vm.$route.name),
                              title: "No existen documentos para mostrar",
                              hiddenDescription: _vm.hiddenBtnEmpty,
                              height: _vm.routeList.includes(_vm.$route.name)
                                ? 199
                                : 280,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "actions",
                                  fn: function () {
                                    return [
                                      !_vm.routeList.includes(
                                        _vm.$route.name
                                      ) && _vm.hiddenBtnEmpty
                                        ? [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "grey-900",
                                                  ripple: false,
                                                  width: 153,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$emit(
                                                      "activeBtnFilter"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "mr-2" },
                                                  [_vm._v("mdi-filter-plus")]
                                                ),
                                                _vm._v("Filtrar"),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "ml-2",
                                                attrs: {
                                                  outlined: "",
                                                  ripple: false,
                                                  width: "153",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.latestRecords()
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "mr-2" },
                                                  [
                                                    _vm._v(
                                                      "mdi-text-search-variant"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v("Últimos registros"),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1633689393
                            ),
                          })
                        : [
                            _c("v-data-table", {
                              class: [
                                {
                                  "table-not-rounded": [
                                    "BranchRetrieveUpdate",
                                    "PosRetrieveUpdate",
                                    "DocumentsRetrieve",
                                    "CustomerRetrieveUpdate",
                                  ].includes(_vm.$route.name),
                                },
                                {
                                  "fixed-table":
                                    _vm.$store.state.base
                                      .isExpandNavigationDrawer,
                                },
                              ],
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                headers: _vm.currentHeader,
                                items: _vm.documentsList,
                                "items-per-page":
                                  _vm.pageSize || _vm.pagination,
                                "hide-default-header": "",
                                "disable-sort": "",
                                "hide-default-footer": "",
                                "mobile-breakpoint": "300",
                                "item-key": "id",
                                "show-select": ![
                                  "BranchRetrieveUpdate",
                                  "PosRetrieveUpdate",
                                  "DocumentsRetrieve",
                                  "CustomerRetrieveUpdate",
                                  "DocumentsBatchRetrieve",
                                  "SupplierRetrieveUpdate",
                                ].includes(_vm.$route.name),
                                "checkbox-color": "green-500",
                                "fixed-header": ![
                                  "BranchRetrieveUpdate",
                                  "PosRetrieveUpdate",
                                  "DocumentsRetrieve",
                                  "CustomerRetrieveUpdate",
                                  "DocumentsBatchRetrieve",
                                  "SupplierRetrieveUpdate",
                                ].includes(_vm.$route.name),
                                height: _vm.heightTable,
                              },
                              on: {
                                "click:row": (documentsList) => {
                                  _vm.goTo(documentsList?.id)
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function ({ props: { headers } }) {
                                      return [
                                        _c("VTableHeaders", {
                                          attrs: {
                                            headers: headers,
                                            resetCheckbox: _vm.resetCheckbox,
                                          },
                                          on: {
                                            sort: _vm.setSort,
                                            toggleAll: _vm.toggleAll,
                                            isSelected: function ($event) {
                                              _vm.isSelected = $event
                                            },
                                            toggleDropdown: function ($event) {
                                              _vm.toggleDropdown = $event
                                            },
                                          },
                                        }),
                                        _c("v-divider", {
                                          staticStyle: {
                                            position: "absolute",
                                            "margin-top": "-6px",
                                            "min-width": "100%",
                                            "margin-left": "-5px",
                                            "z-index": "2",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.customer`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "grey-700--text text-decoration-none",
                                            attrs: {
                                              to: {
                                                name: "DocumentsRetrieve",
                                                params: {
                                                  ..._vm.currentParams,
                                                  id: item.id,
                                                },
                                              },
                                            },
                                          },
                                          [
                                            item?.customer_name
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "d-inline-block text-truncate",
                                                    class:
                                                      _vm.routeList.includes(
                                                        _vm.$route.name
                                                      )
                                                        ? "body-2"
                                                        : "body-1 mb-n2",
                                                    staticStyle: {
                                                      "max-width": "96%",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item?.customer_name
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    class: `${
                                                      _vm.routeList.includes(
                                                        _vm.$route.name
                                                      )
                                                        ? "body-2"
                                                        : "body-1"
                                                    }, text--disabled font-italic`,
                                                  },
                                                  [_vm._v("Sin especificar")]
                                                ),
                                            item?.customer_tax_id
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "caption grey-300--text d-block",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("generals.RUT")
                                                      ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.formatRut(
                                                            item?.customer_tax_id
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    class: `${
                                                      _vm.routeList.includes(
                                                        _vm.$route.name
                                                      )
                                                        ? "body-2"
                                                        : "body-1"
                                                    }, text--disabled font-italic`,
                                                  },
                                                  [_vm._v("Sin especificar")]
                                                ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.customer_name`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "grey-700--text text-decoration-none",
                                            attrs: {
                                              to: {
                                                name: "DocumentsRetrieve",
                                                params: {
                                                  ..._vm.currentParams,
                                                  id: item.id,
                                                },
                                              },
                                            },
                                          },
                                          [
                                            item.customer_name
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "d-inline-block text-truncate",
                                                    class:
                                                      _vm.routeList.includes(
                                                        _vm.$route.name
                                                      )
                                                        ? "body-2"
                                                        : "body-1 mb-n2",
                                                    staticStyle: {
                                                      "max-width": "100%",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.customer_name)
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    class: `${
                                                      _vm.routeList.includes(
                                                        _vm.$route.name
                                                      )
                                                        ? "body-2"
                                                        : "body-1"
                                                    }, text--disabled font-italic`,
                                                  },
                                                  [_vm._v("Sin especificar")]
                                                ),
                                            item.customer_tax_id
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "caption grey-300--text d-block",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("generals.RUT")
                                                      ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.formatRut(
                                                            item?.customer_tax_id
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    class: `${
                                                      _vm.routeList.includes(
                                                        _vm.$route.name
                                                      )
                                                        ? "body-2"
                                                        : "body-1"
                                                    }, text--disabled font-italic`,
                                                  },
                                                  [_vm._v("Sin especificar")]
                                                ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.type`,
                                    fn: function ({ item }) {
                                      return [
                                        _vm.$route.name ===
                                        "DocumentsBatchRetrieve"
                                          ? _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "grey-700--text text-decoration-none",
                                                attrs: {
                                                  to: {
                                                    name: "DocumentsRetrieve",
                                                    params: {
                                                      ..._vm.currentParams,
                                                      id: item.id,
                                                    },
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class:
                                                      _vm.routeList.includes(
                                                        _vm.$route.name
                                                      )
                                                        ? "body-2"
                                                        : "body-1",
                                                    staticStyle: {
                                                      "white-space":
                                                        "normal !important",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "nameDocumentsType"
                                                        )(item.type)
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "grey-700--text text-decoration-none",
                                                attrs: {
                                                  to: {
                                                    name: "DocumentsRetrieve",
                                                    params: {
                                                      ..._vm.currentParams,
                                                      id: item.id,
                                                    },
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class:
                                                      _vm.routeList.includes(
                                                        _vm.$route.name
                                                      )
                                                        ? "body-2"
                                                        : "body-1",
                                                    staticStyle: {
                                                      "white-space":
                                                        "normal !important",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "nameDocumentsType"
                                                        )(item.type)
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.number`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-center justify-end",
                                          },
                                          [
                                            item.assignment_agency_status
                                              ? _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      color: "grey-background",
                                                      right: "",
                                                      transition:
                                                        "scale-transition",
                                                      "max-width": "250",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "v-avatar",
                                                                _vm._g(
                                                                  {
                                                                    staticClass:
                                                                      "mr-2",
                                                                    attrs: {
                                                                      color:
                                                                        "grey-900",
                                                                      size: "24",
                                                                    },
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "white",
                                                                        size: "12",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-file-arrow-left-right"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "px-3 py-2",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "d-block font-weight-bold",
                                                          },
                                                          [_vm._v("Cedido")]
                                                        ),
                                                        item.assignee_tax_id
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "d-block",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "generals.RUT"
                                                                    )
                                                                  ) +
                                                                    ": " +
                                                                    _vm._s(
                                                                      item.assignee_tax_id
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        item.assignee_name
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "d-block",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.assignee_name
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                class: _vm.routeList.includes(
                                                  _vm.$route.name
                                                )
                                                  ? "body-2"
                                                  : "body-1",
                                              },
                                              [_vm._v(_vm._s(item.number))]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.date`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: _vm.routeList.includes(
                                              _vm.$route.name
                                            )
                                              ? "body-2"
                                              : "body-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm._f("date")(item.date))
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.created`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: _vm.routeList.includes(
                                              _vm.$route.name
                                            )
                                              ? "body-2"
                                              : "body-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("dateTimeSecond")(
                                                  item.created
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.status`,
                                    fn: function ({ item }) {
                                      return [
                                        _c("chip-status", {
                                          attrs: {
                                            status: item.status
                                              ? item.status
                                              : "CRE",
                                            type: "documents",
                                            detail:
                                              item?.agency_status_detail_list ||
                                              item?.agency_status_info
                                                ? `${
                                                    _vm.setTooltip(
                                                      item.agency_status_detail_list
                                                    ) || item.agency_status_info
                                                  }`
                                                : null,
                                            isTooltip: true,
                                            isActivePopover: true,
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.rec_status`,
                                    fn: function ({ item }) {
                                      return [
                                        item.rec_status
                                          ? _c("chip-status", {
                                              attrs: {
                                                status: item.rec_status,
                                                detail:
                                                  item?.rec_status_info &&
                                                  item?.rec_status_info !==
                                                    "null"
                                                    ? item.rec_status_info
                                                    : null,
                                                type: "purchases",
                                                isTooltip: true,
                                                isActivePopover: true,
                                              },
                                            })
                                          : _c(
                                              "span",
                                              { staticClass: "text--disabled" },
                                              [_vm._v("-")]
                                            ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.assignment_agency_status`,
                                    fn: function ({ item }) {
                                      return [
                                        item.assignment_agency_status
                                          ? _c("chip-status", {
                                              attrs: {
                                                status:
                                                  item.assignment_agency_status,
                                                type: "assign",
                                                isTooltip: true,
                                                isActivePopover: true,
                                              },
                                            })
                                          : _c(
                                              "span",
                                              { staticClass: "text--disabled" },
                                              [_vm._v("-")]
                                            ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.amount_net`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: _vm.routeList.includes(
                                              _vm.$route.name
                                            )
                                              ? "body-2"
                                              : "body-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$fmt.currency(
                                                  item?.currency ||
                                                    _vm.$store?.state?.auth
                                                      ?.account?.currency,
                                                  item.amount_net
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.amount_exempt`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: _vm.routeList.includes(
                                              _vm.$route.name
                                            )
                                              ? "body-2"
                                              : "body-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$fmt.currency(
                                                  item?.currency ||
                                                    _vm.$store?.state?.auth
                                                      ?.account?.currency,
                                                  item.amount_exempt
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.amount_tax`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: _vm.routeList.includes(
                                              _vm.$route.name
                                            )
                                              ? "body-2"
                                              : "body-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$fmt.currency(
                                                  item?.currency ||
                                                    _vm.$store?.state?.auth
                                                      ?.account?.currency,
                                                  item.amount_tax
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.amount_total`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: _vm.routeList.includes(
                                              _vm.$route.name
                                            )
                                              ? "body-2"
                                              : "body-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$fmt.currency(
                                                  item?.currency ||
                                                    _vm.$store?.state?.auth
                                                      ?.account?.currency,
                                                  item.amount_total
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.actions`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              "close-on-click": "",
                                              "close-on-content-click": "",
                                              "offset-y": "",
                                              left: "",
                                              "nudge-left": 10,
                                              "nudge-bottom": 10,
                                              transition: "slide-y-transition",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "mr-n4",
                                                              attrs: {
                                                                text: "",
                                                                "x-small": "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.current =
                                                                      item
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "grey-500",
                                                                size: "24",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-dots-vertical"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "v-list",
                                              { staticClass: "pa-0" },
                                              [
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    staticClass: "px-3",
                                                    attrs: { ripple: false },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.renderDocument2(
                                                          "documents",
                                                          null,
                                                          "pdf",
                                                          item.id
                                                        ),
                                                          _vm.fetchPdfTemplates(
                                                            item.type
                                                          ),
                                                          (_vm.resetPDF += 1)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "d-flex align-center body-1 grey-500--text",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color: "grey-700",
                                                              size: "20",
                                                              left: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-text-box"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v("Ver PDF"),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm.$store.state.auth.account
                                                  .country !== "PE"
                                                  ? [
                                                      _vm._l(
                                                        _vm.getAvailableNotes(
                                                          item
                                                        ),
                                                        function (note) {
                                                          return _c(
                                                            "v-list-item",
                                                            {
                                                              key: `note-${item.id}-${note}`,
                                                              staticClass:
                                                                "px-3",
                                                              attrs: {
                                                                ripple: false,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.handleNoteClickFromList(
                                                                      item,
                                                                      note
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-title",
                                                                {
                                                                  staticClass:
                                                                    "d-flex align-center body-1 grey-500--text",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "grey-700",
                                                                        size: "20",
                                                                        left: "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-email"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.getNoteLabel(
                                                                          note
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      _c(
                                                        "v-list-item",
                                                        {
                                                          staticClass: "px-3",
                                                          attrs: {
                                                            ripple: false,
                                                            to: {
                                                              name: "DocumentsClone",
                                                              params: {
                                                                id: item.id,
                                                                ..._vm.$route
                                                                  .params,
                                                              },
                                                              query: {
                                                                document_type:
                                                                  item.type,
                                                              },
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "d-flex align-center body-1 grey-500--text",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey-700",
                                                                    size: "20",
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-file-multiple"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "Duplicar "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      item.type === "CL52"
                                                        ? _c(
                                                            "v-list-item",
                                                            {
                                                              staticClass:
                                                                "px-3",
                                                              attrs: {
                                                                ripple: false,
                                                                to: {
                                                                  name: "DocumentsClone",
                                                                  params: {
                                                                    id: item.id,
                                                                    ..._vm
                                                                      .$route
                                                                      .params,
                                                                  },
                                                                  query: {
                                                                    document_type:
                                                                      "CL33",
                                                                    document_parent:
                                                                      item.type,
                                                                  },
                                                                },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-title",
                                                                {
                                                                  staticClass:
                                                                    "d-flex align-center body-1 grey-500--text",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "grey-700",
                                                                        size: "20",
                                                                        left: "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-file-document-edit-outline"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    "Facturar guía de despacho "
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  : _vm._e(),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    staticClass: "px-3",
                                                    attrs: { ripple: false },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.downloadFile2(
                                                          "documents",
                                                          `${item.type}_${item.number}`,
                                                          null,
                                                          "xml",
                                                          item.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "d-flex align-center body-1 grey-500--text",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color: "grey-700",
                                                              size: "20",
                                                              left: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-code-braces-box"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "Descargar documento"
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                ["APR", "OBS"].includes(
                                                  item.status
                                                ) &&
                                                _vm.$store?.state?.auth?.account
                                                  ?.country !== "CL"
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        staticClass: "px-3",
                                                        attrs: {
                                                          ripple: false,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.downloadFile2(
                                                              "documents",
                                                              `${item.type}_${item.number}`,
                                                              null,
                                                              "voucher",
                                                              item.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "d-flex align-center body-1 grey-500--text",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "grey-700",
                                                                  size: "20",
                                                                  left: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-code-braces-box"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              "Descargar CDR"
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                item.assignment_agency_status
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        staticClass: "px-3",
                                                        attrs: {
                                                          ripple: false,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.downloadFile2(
                                                              "documents",
                                                              `${item.type}_${item.number}_AEC`,
                                                              null,
                                                              "aec",
                                                              item.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "d-flex align-center body-1 grey-500--text",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "grey-700",
                                                                  size: "20",
                                                                  left: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-code-braces-box"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              "Descargar AEC"
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.$store?.state?.auth?.account
                                                  ?.country === "CL" &&
                                                item.type === "CL52" &&
                                                ["APR", "OBS"].includes(
                                                  item.status
                                                ) &&
                                                _vm.$helpers.hasPermission([
                                                  "void_document",
                                                ])
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        staticClass: "px-3",
                                                        attrs: {
                                                          ripple: false,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.dialogMarkAsAnulled = true
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "d-flex align-center body-1 grey-500--text",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "grey-700",
                                                                  size: "20",
                                                                  left: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-file-cancel-outline"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              "Marcar como nulo"
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.selected,
                                callback: function ($$v) {
                                  _vm.selected = $$v
                                },
                                expression: "selected",
                              },
                            }),
                            _vm.showPagination || _vm.showAll
                              ? _c("VMainPagination", {
                                  attrs: {
                                    titleShowAll: "Ver todos los documentos",
                                    count: _vm.count,
                                    pageSize: _vm.pageSize,
                                    redirect: "DocumentsList",
                                  },
                                })
                              : _vm._e(),
                          ],
                    ],
              ],
          _c(
            "v-dialog",
            {
              attrs: {
                width: "700",
                persistent: "",
                scrollable: "",
                "no-click-animation": "",
                "overlay-color": "grey-500",
              },
              model: {
                value: _vm.modalRender,
                callback: function ($$v) {
                  _vm.modalRender = $$v
                },
                expression: "modalRender",
              },
            },
            [
              _c("render-pdf", {
                key: _vm.resetPDF,
                attrs: {
                  basicRender: true,
                  documentType: _vm._f("nameDocumentsType")(_vm.current.type),
                  number: _vm.current.number,
                  loaderRender: _vm.loaderRender,
                  renderUrl: _vm.renderUrl,
                  formatPDF: _vm.formatPDF,
                  showFormat: true,
                  templates: _vm.pdfTemplates,
                  selectedTemplate: _vm.selectedTemplate,
                  showTemplateSelector: true,
                },
                on: {
                  close: function ($event) {
                    ;(_vm.modalRender = false),
                      (_vm.selectedTemplate = null),
                      (_vm.pdfTemplates = [])
                  },
                  "update:formatPDF": function ($event) {
                    _vm.formatPDF = $event
                  },
                  "update:format-p-d-f": function ($event) {
                    _vm.formatPDF = $event
                  },
                  "update:selectedTemplate": function ($event) {
                    _vm.selectedTemplate = $event
                  },
                  "update:selected-template": function ($event) {
                    _vm.selectedTemplate = $event
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                width: "560",
                persistent: "",
                "no-click-animation": "",
                "overlay-color": "grey-500",
              },
              model: {
                value: _vm.createDocumentDialog,
                callback: function ($$v) {
                  _vm.createDocumentDialog = $$v
                },
                expression: "createDocumentDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: "transparent",
                          attrs: { flat: "", height: "46" },
                        },
                        [
                          _c(
                            "v-toolbar-title",
                            {
                              staticClass:
                                "px-5 subtitle-2 grey-700--text font-weight-semibold",
                            },
                            [_vm._v("Crear documento")]
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-toolbar-items",
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "mr-3",
                                  attrs: { align: "center", justify: "center" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        small: "",
                                        "retain-focus-on-click": "",
                                      },
                                      on: {
                                        click: _vm.closeCreateDocumentDialog,
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: "grey-500",
                                            size: "20",
                                          },
                                        },
                                        [_vm._v("mdi-close")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-text",
                    { staticClass: "px-5 py-4" },
                    [
                      _c(
                        "v-row",
                        { staticClass: "pt-2", attrs: { align: "center" } },
                        [
                          _c("v-col", { attrs: { cols: "4" } }, [
                            _c("img", {
                              attrs: {
                                src: require(`@/assets/backgrounds/modal-document-clone.svg`),
                                width: 148,
                              },
                            }),
                          ]),
                          _c(
                            "v-col",
                            { staticClass: "pr-4 pl-4" },
                            [
                              _c(
                                "v-list",
                                { staticClass: "v-list-form pa-0 transparent" },
                                [
                                  _c(
                                    "v-list-item",
                                    { staticClass: "pa-0 mb-4" },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "grey-500--text body-1 font-weight-semibold mb-3",
                                              staticStyle: {
                                                "white-space": "normal",
                                                "word-wrap": "break-word",
                                                "line-height": "1.4",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "Crear " +
                                                  _vm._s(
                                                    (
                                                      (
                                                        _vm.DocumentTypesList.find(
                                                          (d) =>
                                                            d.id ===
                                                            _vm.cloneDoc
                                                        ) || {}
                                                      ).name || ""
                                                    ).toLowerCase()
                                                  )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "mt-1 mb-3" },
                                            [
                                              _c(
                                                "v-radio-group",
                                                {
                                                  staticClass: "ma-0",
                                                  attrs: {
                                                    column: "",
                                                    dense: "",
                                                    "hide-details": "",
                                                  },
                                                  model: {
                                                    value: _vm.actionCreateDoc,
                                                    callback: function ($$v) {
                                                      _vm.actionCreateDoc = $$v
                                                    },
                                                    expression:
                                                      "actionCreateDoc",
                                                  },
                                                },
                                                [
                                                  _c("v-radio", {
                                                    staticClass: "mb-2",
                                                    attrs: {
                                                      label:
                                                        "Anula documento de referencia",
                                                      value: "1",
                                                    },
                                                  }),
                                                  _c("v-radio", {
                                                    staticClass: "mb-2",
                                                    attrs: {
                                                      label:
                                                        "Corrige texto documento de referencia",
                                                      value: "2",
                                                    },
                                                  }),
                                                  _c("v-radio", {
                                                    attrs: {
                                                      label: "Corrige montos",
                                                      value: "3",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        { staticClass: "mt-n1 d-block grey-700--text body-1" },
                        [_vm._v("Descripción del documento")]
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "pa-0" },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "",
                                  maxlength: "90",
                                },
                                model: {
                                  value: _vm.noteReason,
                                  callback: function ($$v) {
                                    _vm.noteReason = $$v
                                  },
                                  expression: "noteReason",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    { staticClass: "py-2 px-5" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { outlined: "", ripple: false },
                          on: { click: _vm.closeCreateDocumentDialog },
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "grey-900",
                            disabled: !_vm.actionCreateDoc || !_vm.noteReason,
                            ripple: false,
                          },
                          on: { click: _vm.createNoteDocument },
                        },
                        [_vm._v(" Crear documento ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                width: "792",
                persistent: "",
                "no-click-animation": "",
                "overlay-color": "grey-500",
              },
              model: {
                value: _vm.dialogMarkAsAnulled,
                callback: function ($$v) {
                  _vm.dialogMarkAsAnulled = $$v
                },
                expression: "dialogMarkAsAnulled",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: "transparent",
                          attrs: { flat: "", height: "46" },
                        },
                        [
                          _c(
                            "v-toolbar-title",
                            {
                              staticClass:
                                "px-5 subtitle-2 grey-700--text font-weight-semibold",
                            },
                            [_vm._v("Marcar como nulo")]
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-toolbar-items",
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "mr-3",
                                  attrs: { align: "center", justify: "center" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        small: "",
                                        "retain-focus-on-click": "",
                                      },
                                      on: { click: _vm.closeMarkAsAnulled },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: "grey-500",
                                            size: "20",
                                          },
                                        },
                                        [_vm._v("mdi-close")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-text",
                    { staticClass: "py-4 px-5 grey-500--text" },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "pt-2 pb-4",
                          attrs: { align: "center" },
                        },
                        [
                          _c("v-col", { attrs: { cols: "3" } }, [
                            _c("img", {
                              attrs: {
                                src: require(`@/assets/backgrounds/modal-document-null.svg`),
                                width: 148,
                              },
                            }),
                          ]),
                          _c(
                            "v-col",
                            { staticClass: "pr-4 pl-4" },
                            [
                              _c(
                                "div",
                                { staticClass: "mt-1 mb-3" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { color: "grey-700", size: "14" },
                                    },
                                    [_vm._v("mdi-file-document")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "body-2 font-weight-medium text-uppercase",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("nameDocumentsType")(
                                            _vm.current.type || ""
                                          )
                                        ) +
                                          " Nº" +
                                          _vm._s(_vm.current.number)
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "span",
                                { staticClass: "d-block body-1 pt-2" },
                                [
                                  _vm._v(
                                    "Al marcar como nulo un documento, sólo lo estás anulando en la plataforma y no en " +
                                      _vm._s(_vm.$t("generals.SII")) +
                                      "."
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticClass: "d-block body-1 mt-4 mb-3" },
                                [
                                  _vm._v("Escribe "),
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("“confirmar”")]
                                  ),
                                  _vm._v(" para continuar."),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  "single-line": "",
                                  maxlength: "9",
                                  dense: "",
                                  "hide-details": "",
                                },
                                on: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    _vm.confirm.toLowerCase() === "confirmar" &&
                                      _vm.markAsAnulled()
                                  },
                                },
                                model: {
                                  value: _vm.confirm,
                                  callback: function ($$v) {
                                    _vm.confirm = $$v
                                  },
                                  expression: "confirm",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    { staticClass: "py-2 px-5" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { outlined: "" },
                          on: { click: _vm.closeMarkAsAnulled },
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "grey-900",
                            loading: _vm.loadingAnulled,
                            disabled: _vm.confirm.toLowerCase() !== "confirmar",
                          },
                          on: { click: _vm.markAsAnulled },
                        },
                        [_vm._v("Confirmar")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }